import { Time } from '@eagle/common';
import { useQuery } from '@tanstack/react-query';
import { useAuthenticated } from '../auth';

interface UiTemplateResponse {
  template: object;
  loaded: boolean;
}

export const useUiTemplate = (id: string, fallback: object, additionalParams?: Record<string, string>, deps: string[] = [], enabled = true): UiTemplateResponse => {
  const { account, restClient } = useAuthenticated();

  const { data: template, status } = useQuery({
    queryKey: ['ui-template', id, account, additionalParams, deps],
    enabled,
    staleTime: Time.minutes(1),
    queryFn: async () => {
      const response = await restClient.uiTemplate.get(id, {
        accountId: account._id,
        ...(account.homeDomain ? { domain: account.homeDomain } : {}),
        ...additionalParams,
      });
      return response[0]?.data ?? null;
    },
  });

  return { template: template ?? fallback, loaded: status !== 'pending' };
};
